import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { InvitesState } from '@/store/invites/types';

export const getters: GetterTree<InvitesState, RootState> = {
  defaultInvite(state: InvitesState) {
    return state.invites?.items.find((invite) => invite.attributes?.isDefault && invite.ritual === null);
  },
};
